function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.125 5.5C13.9413 7.97828 12.0625 10 10 10C7.93754 10 6.05551 7.97875 5.87504 5.5C5.68754 2.92188 7.51566 1 10 1C12.4844 1 14.3125 2.96875 14.125 5.5Z",
  stroke: "#2E7AE2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.06023 13.0717C2.58109 14.222 0.577151 16.3008 0.0327383 19.3194C-0.0542797 19.8017 0.028783 20.3258 0.322658 20.7552C0.631908 21.207 1.14329 21.5 1.74999 21.5H18.25C18.8566 21.5 19.3681 21.2073 19.6776 20.7554C19.9717 20.3259 20.0547 19.8017 19.9677 19.3193L19.9677 19.3193C19.0842 14.4236 14.3621 12 9.99998 12C9.45997 12 8.91444 12.0371 8.37135 12.1115L10.3106 14.0046C13.9249 14.1129 17.2547 16.1064 17.9655 19.5H2.03495C2.53473 17.1125 4.33101 15.4179 6.61078 14.5853L5.06023 13.0717ZM18.0006 19.6874C18.0005 19.6874 18.0005 19.6864 18.0007 19.6845C18.0008 19.6865 18.0007 19.6874 18.0006 19.6874ZM1.99982 19.6874C1.99975 19.6874 1.99965 19.6865 1.99973 19.6845C1.99994 19.6864 1.9999 19.6874 1.99982 19.6874Z",
  fill: "#2E7AE2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 7.75L12 17.75",
  stroke: "#2E7AE2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPersonOff = function SvgPersonOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPersonOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person_off.bbeeb302.svg";
export { ForwardRef as ReactComponent };